import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getBranding } from '../config/branding';

/**
 * The multi-platform constructor's entry point, next to "New Campaign".
 * Always opens /sense-max; the page itself shows a "choose a client"
 * placeholder when no specific client is selected.
 *
 * The module is branded per edition: "Sense Max" with a lightning mark on the
 * main instance, "<brand> omni" with the connection mark on a white-label, where
 * the product is sold under the partner's own name. Same button, same route —
 * only the face changes, so callers stay unaware of the edition.
 */
interface Props {
  className?: string;
  label?: string;
}

const SenseMaxButton: React.FC<Props> = ({ className, label }) => {
  const navigate = useNavigate();
  const branding = getBranding();
  const whiteLabel = branding.edition !== 'sense';
  const open = () => navigate('/sense-max');

  if (whiteLabel) {
    return (
      <button className={className ?? 'btn-omni'} onClick={open}>
        {/* three nodes joined by arcs — the omni mark */}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M9.6 2.2c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4zM19.6 12.6c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4 1.5-3.4 3.4-3.4zM4.4 14.8c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4S1 20.1 1 18.2s1.5-3.4 3.4-3.4z" />
          <path d="M6.2 8.4c-1 1.2-1.7 2.6-2.1 4.1" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          <path d="M16.7 10c-1-.9-2.2-1.6-3.5-2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          <path d="M15.4 17.6c-1.6.5-3.3.6-5 .2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
        {label ?? branding.brand_name.toLowerCase()}
        <span className="omni-badge">omni</span>
      </button>
    );
  }

  return (
    <button className={className ?? 'btn btn-max'} onClick={open}>
      {/* lightning / "max" mark */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
        <path d="M13 2L4.5 13.5H11l-1 8.5L19.5 10H13l0-8z" />
      </svg>
      {label ?? 'Sense Max'}
      <span className="btn-max-badge">MAX</span>
    </button>
  );
};

export default SenseMaxButton;
